/**
 * Created by Ivan on 10.08.2026
 */

cleverapps.override(cleverapps.EVENTS, {
    STICKERS2_COLLECTIONS: "stickers2_cl_",
    STICKERS2_DAU: "stickers2_dau",
    STICKER2_OPEN: "sticker2_",
    STICKER2_DUPLICATE: "sticker2_dup_",
    STICKERS2_BOOK_WINDOW_OPEN: "stickers2_window",
    STICKERS2_SHOP_OPEN: "stickers2_shop",
    SPENT: {
        STICKERS2_1: "stickers2pack1",
        STICKERS2_2: "stickers2pack2",
        STICKERS2_3: "stickers2pack3",
        STICKERS2_4: "stickers2pack4",
        STICKERS2_5: "stickers2pack5",
        STICKERS2_6: "stickers2pack6",
        STICKERS2_POINTS: "stickers2points"
    }
});
